import businessDays from 'business-days-js'

type EstimatedArrivalTime = {
  [key: string]: {
    [key: string]: {
      min: number
      max: number
    }
  }
}

export const estimationShippingArrivalTime: EstimatedArrivalTime = {
  US: {
    standard: {
      min: 7,
      max: 14,
    },
  },
  CA: {
    standard: {
      min: 7,
      max: 14,
    },
  },
  NZ: {
    standard: {
      min: 7,
      max: 14,
    },
  },
  AU: {
    standard: {
      min: 7,
      max: 14,
    },
  },
  default: {
    standard: {
      min: 15,
      max: 25,
    },
  },
}

export const getEstimatedArrivalRange = (countryCode: string, shippingType: string) => {
  if (!estimationShippingArrivalTime[countryCode]) {
    return estimationShippingArrivalTime.default[shippingType]
  }
  return estimationShippingArrivalTime[countryCode || 'default'][shippingType]
}

export const formatDaysLater = (
  afterDays: number,
  from: Date = new Date(),
  format: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  },
) => {
  const date = new Date(from)
  const bDays = businessDays()
  const result = bDays.addDays(date, afterDays)
  return result.format(`${format.weekday ? format.weekday === 'short' ? 'ddd,' : 'dddd,' : ''} ${format.month ? format.month === 'short' ? 'MMM' : 'MMMM' : ''} D`)
}
